/* ══════════════════════════════════════════════════════════════════════════
 * CLS-FI — Student Club mock data
 * Fake clubs for the entry form. Will be replaced by API later.
 * ══════════════════════════════════════════════════════════════════════════ */

export const STUDENT_CLUBS = [
  { slug: 'helsinki-opiskelijakerho',     name: 'Helsinki Opiskelijakerho' },
  { slug: 'tampere-opiskelijayhdistys',   name: 'Tampere Opiskelijayhdistys' },
  { slug: 'turku-perjantaibaari',         name: 'Turku Perjantaibaari' },
  { slug: 'oulu-opiskelijatalo',          name: 'Oulu Opiskelijatalo' },
  { slug: 'jyvaskyla-opiskelijakerho',    name: 'Jyväskylä Opiskelijakerho' },
  { slug: 'lahti-nuorisoyhdistys',        name: 'Lahti Nuorisoyhdistys' },
  { slug: 'kuopio-opiskelijaneuvosto',    name: 'Kuopio Opiskelijaneuvosto' },
  { slug: 'pori-opiskelijakerho',         name: 'Pori Opiskelijakerho' },
];

export const getStudentClub = (slug) =>
  STUDENT_CLUBS.find((c) => c.slug === slug) || null;
